var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items && _vm.items.length)?_c('div',{staticClass:"editorBlogSelectedProductsSection"},[_c('LazyHydrate',{attrs:{"when-visible":""}},[_c('flexible-slider-section',{attrs:{"section":{ title: _vm.data.title, data: { products: _vm.items } }}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }